const validCount = value => Number.isSafeInteger(value) && value >= 0;

export function pickQueueSummary(counts, owner = false) {
  if (!counts || !['pending', 'packing', 'needsMatch'].every(key => validCount(counts[key]))) return null;
  const existingTotal = counts.pending + counts.packing + counts.needsMatch;
  const physical = owner && validCount(counts.physicalIssues) ? counts.physicalIssues : 0;
  if (!Number.isSafeInteger(existingTotal) || !existingTotal && !physical) return null;
  const problemText = physical ? `${physical} physical problem${physical === 1 ? '' : 's'}` : '';
  // Problems can overlap a pending/held pick. Show separate counts, not a
  // guessed total number of distinct slabs.
  return {
    text: [existingTotal || '', physical ? `${physical} problem${physical === 1 ? '' : 's'}` : ''].filter(Boolean).join(' · '),
    description: [`${counts.pending} to pick`, `${counts.packing} checked out`, `${counts.needsMatch} need owner review`, problemText].filter(Boolean).join(', '),
  };
}
